import { RouteType } from '@multiversx/sdk-dapp/types';
import { dAppName } from 'config/config';

import { withPageTitle } from './components/PageTitle';

import { Dashboard, Swap, Pools, CreatePool, Farm, CreateFarm, DualFarm, CreateDualFarm, Coming, IDOLaunchpad, Staking, CreateStaking } from './pages';

import createIdo from 'pages/Launchpad/createIdo';
import IdoDetail from 'pages/Launchpad/IdoDetail';

import DASHBOARD_ICO from './assets/img/sidebar/dashboard.png';
import DASHBOARD_ACTIVE_ICO from './assets/img/sidebar/dashboard-active.png';
import SWAP_ICO from './assets/img/sidebar/swap.png';
import SWAP_ACTIVE_ICO from './assets/img/sidebar/swap-active.png';
import POOL_ICO from './assets/img/sidebar/pool.png';
import POOL_ACTIVE_ICO from './assets/img/sidebar/pool-active.png';
import FARM_ICO from './assets/img/sidebar/farm.png';
import FARM_ACTIVE_ICO from './assets/img/sidebar/farm-active.png';
import DUALFARM_ICO from './assets/img/sidebar/dualfarm.png';
import DUALFARM_ACTIVE_ICO from './assets/img/sidebar/dualfarm-active.png';
import STAKING_ICO from './assets/img/sidebar/staking.png';
import STAKING_ACTIVE_ICO from './assets/img/sidebar/staking-active.png';
import LAUNCHPAD_ICO from './assets/img/sidebar/launchpad.png';
import LAUNCHPAD_ACTIVE_ICO from './assets/img/sidebar/launchpad-active.png';

export const routeNames = {
  dashboard: '/',
  swap: '/swap',
  pool: '/pool',
  createPool: '/pool/create',
  farm: '/farm',
  createFarm: '/farm/create',
  dualfarm: '/dualfarm',
  createDualFarm: '/dualfarm/create',
  staking: '/staking',
  createStaking: '/staking/create',
  launchpad: '/lauchpad',
  createLaunchpad: '/lauchpad/create',
  launchpadDetail: '/lauchpad/detail/*',
  unlock: '/unlock'
};

interface RouteWithTitleType extends RouteType {
  title: string;
  icon: any;
  active_icon: any;
  isSubMenu?: boolean;
}

export const routes: RouteWithTitleType[] = [
  {
    path: routeNames.dashboard,
    title: 'Dashboard',
    component: Dashboard,
    icon: DASHBOARD_ICO,
    active_icon: DASHBOARD_ACTIVE_ICO
  },
  {
    path: routeNames.swap,
    title: 'Swap',
    component: Swap,
    icon: SWAP_ICO,
    active_icon: SWAP_ACTIVE_ICO
  },
  // {
  //   path: routeNames.liquidity,
  //   title: 'Liquidity',
  //   component: Liquidity,
  //   icon: faFlask
  // },
  {
    path: routeNames.pool,
    title: 'Pools',
    component: Pools,
    icon: POOL_ICO,
    active_icon: POOL_ACTIVE_ICO
  },
  {
    path: routeNames.createPool,
    title: 'Create Pool',
    component: CreatePool,
    icon: POOL_ICO,
    active_icon: POOL_ACTIVE_ICO,
    isSubMenu: true
  },
  {
    path: routeNames.farm,
    title: 'Farms',
    component: Farm,
    icon: FARM_ICO,
    active_icon: FARM_ACTIVE_ICO,
  },
  {
    path: routeNames.createFarm,
    title: 'Create Farm',
    component: CreateFarm,
    isSubMenu: true,
    icon: FARM_ICO,
    active_icon: FARM_ACTIVE_ICO,
  },
  {
    path: routeNames.dualfarm,
    title: 'Dual Farms',
    component: DualFarm,
    icon: DUALFARM_ICO,
    active_icon: DUALFARM_ACTIVE_ICO,
  },
  {
    path: routeNames.createDualFarm,
    title: 'Create Dual Farm',
    component: CreateDualFarm,
    isSubMenu: true,
    icon: DUALFARM_ICO,
    active_icon: DUALFARM_ACTIVE_ICO,
  },
  {
    path: routeNames.staking,
    title: 'Staking',
    component: Staking,
    icon: STAKING_ICO,
    active_icon: STAKING_ACTIVE_ICO,
  },
  {
    path: routeNames.createStaking,
    title: 'Create Staking',
    component: CreateStaking,
    isSubMenu: true,
    icon: STAKING_ICO,
    active_icon: STAKING_ACTIVE_ICO,
  },
  {
    path: routeNames.launchpad,
    title: 'Launchpad',
    component: IDOLaunchpad,
    icon: LAUNCHPAD_ICO,
    active_icon: LAUNCHPAD_ACTIVE_ICO,
  },
  {
    path: routeNames.createLaunchpad,
    title: 'Created Launchpad',
    component: createIdo,
    icon: LAUNCHPAD_ICO,
    active_icon: LAUNCHPAD_ACTIVE_ICO,
    isSubMenu: true,
  },
  {
    path: routeNames.launchpadDetail,
    title: 'Launchpad Detail',
    component: IdoDetail,
    icon: LAUNCHPAD_ICO,
    active_icon: LAUNCHPAD_ACTIVE_ICO,
    isSubMenu: true,
  }
];

export const mappedRoutes = routes.map((route) => {
  const title = route.title
    ? `${route.title} • ${dAppName}`
    : `${dAppName}`;

  const requiresAuth = Boolean(route.authenticatedRoute);
  const wrappedComponent = withPageTitle(title, route.component);

  return {
    path: route.path,
    component: wrappedComponent,
    authenticatedRoute: requiresAuth
  };
});
